export { default as Header } from './component';


// WEBPACK FOOTER //
// ./src/components/mainLayout/header/index.js